/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Top of book source creation request
 */
export interface TopOfBookSourceRequest {
  type: TopOfBookSourceRequest.TypeEnum;
  name: string;
  pairId: number;
  source1?: number;
  weight1?: number;
  source2?: number;
  weight2?: number;
  source3?: number;
  weight3?: number;
  source4?: number;
  weight4?: number;
  enabled: boolean;
}
export namespace TopOfBookSourceRequest {
  export const TypeEnum = {
    BinanceSpot: 'BINANCE_SPOT',
    BinancePerpetual: 'BINANCE_PERPETUAL',
    BybitSpot: 'BYBIT_SPOT',
    BybitPerpetual: 'BYBIT_PERPETUAL',
    OkxSpot: 'OKX_SPOT',
    OkxPerpetual: 'OKX_PERPETUAL',
    Aggregate: 'AGGREGATE',
    Multiply: 'MULTIPLY',
    Divide: 'DIVIDE',
    PerpSpotChaining: 'PERP_SPOT_CHAINING',
    LiquidityProvider: 'LIQUIDITY_PROVIDER',
    CoinbasePerpetual: 'COINBASE_PERPETUAL',
    KrakenSpot: 'KRAKEN_SPOT',
    CoinbaseSpot: 'COINBASE_SPOT',
  } as const;
  export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
